import Image from "next/image"

import ErrorSVG from "@/shared/assets/images/error.svg"
import SuccessSVG from "@/shared/assets/images/success-docuseal.svg"
import TrashSVG from "@/shared/assets/images/trash.svg"
import WarningSVG from "@/shared/assets/images/warning.svg"
import { Button } from "@/shared/shadcn/ui/button-old"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/shared/shadcn/ui/dialog"
import { Label } from "@/shared/shadcn/ui/label"
import { Textarea } from "@/shared/shadcn/ui/textarea"

export interface ConfirmPayload {
  status: "approve" | "decline";
  note?: string;
}

type Props = {
  isLoading?: boolean;
  isLoadingSecondary?: boolean;
  type?: "Info" | "Success" | "Warning" | "Delete" | "Error";
  title?: string;
  subtitle?: string;
  primaryButton?: string;
  secondaryButton?: string;
  isDeclineAndApproved?: boolean;
  isDeclineAndApprove?: string;
  primaryButtonAction?: (payload: ConfirmPayload) => void;
  isOnlyPrimaryButton?: boolean;
  secondaryButtonAction?: () => void;

  open?: boolean;
  setOpen?: (open: boolean) => void;

  reasonDocument?: string;
  setReasonDocument?: (value: string) => void;
}

export default function DialogConfirm({
  isLoading,
  isLoadingSecondary,
  type = "Info",
  title,
  subtitle,
  primaryButton,
  secondaryButton,
  isDeclineAndApproved = false,
  isDeclineAndApprove,

  primaryButtonAction,
  secondaryButtonAction,
  isOnlyPrimaryButton = false,

  open = false,
  setOpen,

  reasonDocument,
  setReasonDocument,
}: Props) {
  const payload: ConfirmPayload = {
    status: isDeclineAndApprove === "Approve" ? "approve" : "decline",
    note: reasonDocument,
  }

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
    >
      <DialogContent
        className={"max-w-[300px] lg:max-w-[370px] bg-white"}
      >
        <DialogHeader>
          {type === "Info" && (
            // <Info size={60} className="mx-auto" color="#F79009" />
            <Image
              alt="warning"
              className="mx-auto w-[120px] lg:w-[209px]"
              height={206}
              priority
              src={WarningSVG}
              width={209}
            />
          )}

          {type === "Warning" && (
            <Image
              alt="warning"
              className="mx-auto w-[120px] lg:w-[209px]"
              height={206}
              priority
              src={WarningSVG}
              width={209}
            />
          )}

          {type === "Delete" && (
            <Image
              alt="trash"
              className="mx-auto w-[120px] lg:w-[209px]"
              height={206}
              priority
              src={TrashSVG}
              width={209}
            />
          )}

          {type === "Success" && (
            <Image
              alt="success"
              className="mx-auto w-[108px]"
              height={108}
              priority
              src={SuccessSVG}
              width={108}
            />
          )}

          {type === "Error" && (
            <Image
              alt="error"
              className="mx-auto w-[57px]"
              height={57}
              priority
              src={ErrorSVG}
              width={57}
            />
          )}

          <DialogTitle className="text-sm lg:text-base font-semibold tracking-wide leading-6 text-center mt-10">
            {title}
          </DialogTitle>
          <DialogDescription className="text-xs text-center mb-10 text-[#404040]">
            {subtitle}
          </DialogDescription>
        </DialogHeader>

        {isDeclineAndApproved && (
          <div className="flex flex-col items-start gap-3">
            <Label>
              Reason for
              {" "}
              {isDeclineAndApprove}
              {" "}
              <span className="text-red-600">*</span>
            </Label>
            <Textarea
              className="border border-[#A6A6A6] placeholder:text-[#A6A6A6] text-black text-[10px] font-normal"
              placeholder="Enter your feedback or reason for rejecting the document..."
              rows={3}
              value={reasonDocument}
              onChange={(e) => setReasonDocument?.(e.target.value)}
            />
          </div>
        )}

        <div className="flex justify-center gap-5">
          {!isOnlyPrimaryButton ? (
            <Button
              className="border-none text-primary w-full"
              disabled={isLoadingSecondary}
              variant="outline"
              onClick={secondaryButtonAction}
            >
              {isLoadingSecondary ? "Loading ..." : secondaryButton}
            </Button>
          ) : null}
          <Button
            className="w-full"
            disabled={isLoading}
            onClick={() => primaryButtonAction?.(payload)}
          >
            {isLoading ? "Loading ..." : primaryButton}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
